import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import withAuthorization from '../higherOrder/withAuthorization'

import { SETTINGS } from '../../constants/routes'
import { setIntroQuestionsState, getUserProfile } from '../../actions'
import { trackGAEvent } from '../utilities/tracking'

import IntroQuestions from '../IntroQuestions/IntroQuestions'
import { QuestionWrapper, QuestionText, QuestionTextSpan, OptionsWrapper } from '../StyledComponents/IntroQuestions/Question'
import Option from '../IntroQuestions/Option'

class IntroQuestionsPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            introShown: false,
        }

        this.startClicked = this.startClicked.bind(this)
        this.skipClicked = this.skipClicked.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        const { sessionState, getProfile } = this.props

        if (!!sessionState && !!sessionState.idToken
            && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }
    }

    componentDidUpdate(prevProps) {
        const { sessionState, getProfile } = this.props
        if (!prevProps.sessionState.idToken && !!sessionState.idToken
            && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }
    }

    startClicked() {
        this.setState({ introShown: true })

        const { sessionState } = this.props
        trackGAEvent('interaction', {
            interaction_value: 'undefined',
            interaction_category: 'Intro-Questions',
            interaction_action: 'questions-start',
            interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
        })
    }

    skipClicked() {
        const { sessionState, history } = this.props

        if (!!sessionState
            && !!sessionState.idToken
            && !!sessionState.authUser) {
            const { token } = sessionState.idToken
            this.props.setIntroQuestionsState(sessionState.authUser.uid, token, 'skipped')
        }

        trackGAEvent('interaction', {
            interaction_value: 'undefined',
            interaction_category: 'Intro-Questions',
            interaction_action: 'questions-skip',
            interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
        })

        history.push(SETTINGS)
    }

    render() {
        if (!this.state.introShown) {
            const text = 'Um dir lästiges eintippen von Einstellungen zu ersparen, haben wir ein paar Fragen vorbereitet. Anhand dieser Fragen werden die Einstellungen dann automatisch generiert. Natürlich kannst du sie anschließend aber immer noch manuell anpassen.'
            const option = {
                label: 'Los geht\'s!',
            }
            const option2 = {
                label: 'Überspringen',
            }

            return (
                <QuestionWrapper>
                    <QuestionText fontSize="1.3rem">
                        <QuestionTextSpan>
                            Hey! <br />
                            {text}
                        </QuestionTextSpan>
                    </QuestionText>
                    <OptionsWrapper>
                        <Option
                            data={option}
                            fullWidth
                            onOptionClicked={this.startClicked}
                        />
                        <Option
                            data={option2}
                            fullWidth
                            onOptionClicked={this.skipClicked}
                        />
                    </OptionsWrapper>
                </QuestionWrapper>
            )
        }

        return (
            <div>
                <IntroQuestions />
            </div>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    sessionState: state.sessionState,
})

export default compose(
    withAuthorization(authCondition),
    withRouter,
    connect(mapStateToProps, {
        setIntroQuestionsState,
        getProfile: getUserProfile,
    })
)(IntroQuestionsPage)



// WEBPACK FOOTER //
// ./src/components/pages/IntroQuestions.js